import { render } from "./AppRightPanel.vue?vue&type=template&id=7a27f8e5"
import script from "./AppRightPanel.vue?vue&type=script&lang=js"
export * from "./AppRightPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dongjoosong/Code/dp7live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__